module.exports = __webpack_public_path__ + "static/media/cart.cd595d76.png";